import React, { useEffect } from "react";
import { MainLayout } from "../MainLayout";
import { Footer } from "../Footer";
import { ExperienceSec2 } from "./ExperienceSec2";
import { Introduction } from "../../Common/Introduction";
import { ExperienceSec6 } from "./ExperienceSec6";

const Experiences = () => {

    const data = {
        title: "LOCAL EXPERIENCES, PROFESSIONALLY MANAGED",
        head: "Empowering Travel Agents With Curated, Authentic and Reliable Experiences",
        text: [
            "At Blueberry DMC, we partner with trusted local operators and guides to bring authentic, safe, and well-managed experiences to your clients. Each activity - be it a city tour, cultural show, desert adventure, or nature expedition, is carefully vetted for quality, safety, and value. With our deep regional knowledge and on-ground coordination, we ensure that every itinerary you offer runs seamlessly, delivering true local flavor without logistical hassles. Through strong local partnerships, we make it easier for travel agents to provide immersive experiences their clients will remember and rely on you for again.",
        ]
    }
    const experienceData = [
        {
            BCategoryId: 1,
            BCategoryName: "Adventure",
            Slug: "adventure",
            ShortDescription: "Embrace the thrill of adventure with breathtaking experiences around the world. From mountain trekking to bungee jumping, each activity is crafted to ignite your senses.",
            ImagePath: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/What%20Would%20You%20Like%20To%20Do/adventure.webp",
        },
        {
            BCategoryId: 2,
            BCategoryName: "Conservation",
            Slug: "conservations",
            ShortDescription: "Collaborate to protect the world’s diverse wildlife and natural habitats. Participate in hands-on conservation programs that support the preservation of invaluable ecosystems.",
            ImagePath: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/What%20Would%20You%20Like%20To%20Do/conservation.webp",
        },
        {
            BCategoryId: 3,
            BCategoryName: "Safaris",
            Slug: "safaris",
            ShortDescription: "Embark on an unforgettable safari to experience iconic wildlife in their natural habitat. Get up close to majestic animals like elephants, lions, and rhinos on a transformative adventure.",
            ImagePath: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/What%20Would%20You%20Like%20To%20Do/safari.webp",
        },
        {
            BCategoryId: 4,
            BCategoryName: "Luxury Travel",
            Slug: "luxury-travel",
            ShortDescription: "Share the excitement of discovery with fellow travelers in curated group experiences. Whether it’s a cultural tour or an adventure, connect with like-minded individuals while exploring new destinations.",
            ImagePath: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/What%20Would%20You%20Like%20To%20Do/luxury%20travel.webp",
        },
        {
            BCategoryId: 5,
            BCategoryName: "Camps",
            Slug: "camps",
            ShortDescription: "Sleep under the stars and immerse yourself in the raw beauty of nature. Luxury riverside campsites offer the perfect base to explore and reconnect with the great outdoors.",
            ImagePath: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/What%20Would%20You%20Like%20To%20Do/camp.webp",
        },
        {
            BCategoryId: 6,
            BCategoryName: "Art & Culture",
            Slug: "art-culture",
            ShortDescription: "Immerse yourself in the rich heritage of diverse cultures through art, music, and dance. Discover vibrant traditions and stories that have shaped the cultural landscape of the region.",
            ImagePath: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/What%20Would%20You%20Like%20To%20Do/art.webp",
        },
        {
            BCategoryId: 7,
            BCategoryName: "Food & Wine",
            Slug: "food-wine",
            ShortDescription: "Indulge in the rich flavors of Africa’s cuisine, from vibrant spices to world-famous wines. Experience the unique fusion of tastes that makes African food a journey like no other.",
            ImagePath: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/What%20Would%20You%20Like%20To%20Do/food.webp",
        },
        {
            BCategoryId: 8,
            BCategoryName: "Relaxation",
            Slug: "relaxation",
            ShortDescription: "Rejuvenate and unwind in peaceful retreats. From tranquil beaches to serene resorts, discover your ideal getaway to relax and restore.",
            ImagePath: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/What%20Would%20You%20Like%20To%20Do/relaxation.webp",
        },
    ];
    
    return (
        <>
            <MainLayout
                bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Local%20Experiences%20(1).webp")'}
                text1={"DISCOVER LOCAL SIDE "}
                text2={"Experiences That Shape Every Destination "}
                button={true}
            />
            <Introduction data={data} />
            <ExperienceSec2 data={experienceData} />
            <ExperienceSec6 />
            <Footer />
        </>
    )
}

export default Experiences;